import { render } from "./courseMenuOld.vue?vue&type=template&id=a315a810&scoped=true"
import script from "./courseMenuOld.vue?vue&type=script&lang=js"
export * from "./courseMenuOld.vue?vue&type=script&lang=js"

import "./courseMenuOld.vue?vue&type=style&index=0&id=a315a810&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a315a810"]])

export default __exports__